import { Box, useTheme } from "@outschool/backpack";
import {
  ClassFormat,
  FeaturedTutorsQuery,
  FeaturedTutorsQueryVariables
} from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";
import { FeaturedTeacherCard } from "@outschool/ui-components-website";
import React from "react";

import PageSectionTitle from "./PageSectionTitle";
import { featuredTutorsQuery } from "./queries/FeaturedTutorsQuery";

export default function PopularTutors() {
  const { t } = useTranslation(
    "client\\components\\tutoring\\TutoringPage\\PopularTutors"
  );
  const theme = useTheme();
  const { data, loading } = useQueryWithPreviousData<
    FeaturedTutorsQuery,
    FeaturedTutorsQueryVariables
  >(featuredTutorsQuery, {
    variables: {
      activityFormat: ClassFormat.OneOnOne
    }
  });

  const tutors = data?.featured?.popularTeachers;
  return (
    <>
      {!loading && !!tutors?.length && (
        <Box>
          <PageSectionTitle title={t("Popular tutors")} />

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              [theme.breakpoints.up("md")]: {
                gridTemplateColumns: "1fr 1fr 1fr 1fr"
              },
              gap: "3rem"
            }}
          >
            {tutors.map(tutor => (
              <FeaturedTeacherCard
                leader={tutor}
                key={`popular-teacher-${tutor.uid}`}
              />
            ))}
          </Box>
        </Box>
      )}
    </>
  );
}
